const Visual = () => {
  return (
    <section id="about" className="about mt-[120px] sm:mt-[230px]">
      <div className="">
        <div className="text">
          <img src="/hi_icon.png" alt="hi" className="mb-4" />
          <p className="text-lg text-blue-400">안녕하세요.</p>
          <strong className="text-lg py-5 block lg:text-5xl md:text-4xl sm:text-3xl lg:leading-snug">
            사용자 경험을 생각하며 화면을 구현하는 윤수정입니다.
          </strong>
          <p className="pt-2 text-zinc-400 break-word sm:text-lg">
            다양한 기술을 습득하는걸 좋아하며 성장하는 습관을 만들어 가고
            있습니다.
          </p>
          <p className="pt-2 text-zinc-400 break-word sm:text-lg">
            항상 새로운 시도를 두려워하지 않는 개발자가 되겠습니다.
          </p>
          <p className="pt-2 text-zinc-400 break-word sm:text-lg">
            꾸준함을 모토로 배움을 멈추지 않겠습니다.
          </p>
          <div className="code pt-mono bg-slate-800 p-4 mt-8 text-sm overflow-auto sm:text-base">
            <div className="min-w-[490px]">
              <p>
                <span className="text-purple-400">const</span>&nbsp;
                <span className="text-sky-500">Soojeong =</span>&nbsp;
                <span className="text-yellow-400">(</span>skill, habit, new,
                steady<span className="text-yellow-400">)</span>&nbsp;
                <span className="text-purple-400">=&gt;</span>&nbsp;
                <span className="text-yellow-400">&#123;</span>
              </p>
              <p className="pl-4">
                <span className="text-sky-500">get</span>
                <span className="text-purple-400">(</span>skill
                <span className="text-purple-400">)</span>;
              </p>
              <p className="pl-4">
                <span className="text-sky-500">growth</span>
                <span className="text-purple-400">(</span>habit
                <span className="text-purple-400">)</span>;
              </p>
              <p className="pl-4">
                <span className="text-sky-500">try</span>
                <span className="text-purple-400">(</span>new
                <span className="text-purple-400">)</span>;
              </p>
              <p className="pl-4">
                <span className="text-sky-500">study</span>
                <span className="text-purple-400">(</span>steady
                <span className="text-purple-400">)</span>;
              </p>
              <p>
                <span className="text-yellow-400">&#125;</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Visual;
